import { useState as c, useEffect as h } from "react";
import { useFunction as m } from "./index2.js";
import { useOnResize as f } from "./index6.js";
const b = ({ dependencies: u, ref: r }) => {
  const [i, s] = c(), n = m(() => {
    s((t) => {
      if (!r.current)
        return;
      const e = r.current.getBBox();
      return e.width === (t == null ? void 0 : t.width) && e.height === (t == null ? void 0 : t.height) && e.x === (t == null ? void 0 : t.x) && e.y === (t == null ? void 0 : t.y) ? t : e;
    });
  });
  return f(r, n), h(() => {
    n();
  }, u), i;
};
export {
  b as useGetSvgBox
};
//# sourceMappingURL=index3.js.map
